import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { selectors as UISelectors } from 'data/ui'
import { selectors as UsersSelectors } from 'data/users'
import { GUEST } from 'data/users/roles'
import { UserAvatar } from 'components/Utils/Avatar'
import { KeyIcon } from 'components/Utils/Icons'

export function UserRow({ user, isCurrentUser, className = undefined }) {
  const isGuest = user.organizationRole === GUEST
  const showEmailInsteadOfUsername =
    user.inviteCreatedAt && !user.inviteAcceptedAt
  return (
    <div className={classNames('flexbox flexbox-align-center', className)}>
      <UserAvatar userId={user.id} size="small" />
      <div className="margin-left-normal font-weight-bold shade-05 flexbox flexbox-align-center">
        {showEmailInsteadOfUsername ? user.email : user.displayName}
        {isCurrentUser && (
          <React.Fragment>
            &nbsp;—&nbsp;
            <span className="primary">you</span>
          </React.Fragment>
        )}
        {isGuest && (
          <React.Fragment>
            <KeyIcon className="margin-left-small shade-20" />
            <span className="margin-left-small shade-20">Guest</span>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

UserRow.propTypes = {
  user: PropTypes.object.isRequired,
  isCurrentUser: PropTypes.bool,
}

export default connect((state, props) => ({
  isCurrentUser: props.user.id === UISelectors.getActiveUserId(state),
}))(UserRow)

export const UserRowFromId = connect((state, props) => ({
  user: UsersSelectors.getUser(state, props.userId),
}))(UserRow)
